let columnsJson = [
    {prop:'id',label:'结算单ID',fixed:'left',width:'80'},
    {prop:'applicant',label:'申请人',fixed:'left',width:'100'},
    {prop:'order_month',label:'月份',fixed:'',width:'100',manyOrder:true},
    {prop:'type',label:'结算单类型',fixed:'',width:'100'},
    {prop:'saleman',label:'销售人员',fixed:'',width:'100',manyOrder:true},
    {prop:'handler',label:'经手人',fixed:'',width:'100',manyOrder:true},
    {prop:'project_name',label:'项目名称',fixed:'',width:'100',manyOrder:true},
    {prop:'platform_name',label:'投放平台',fixed:'',width:'100',manyOrder:true},
    {prop:'media_name',label:'媒体名称',fixed:'',width:'100',manyOrder:true},
    {prop:'amount',label:'订单金额',fixed:'',width:'100',manyOrder:true},
    {prop:'final_amount',label:'修改后的订单最终收入金额',fixed:'',width:'150',manyOrder:true},
    {prop:'invoice_num',label:'开票次数',fixed:'',width:'100',manyOrder:true},
    {prop:'invoice_amount',label:'开票金额',fixed:'',width:'100'},
    {prop:'files',label:'附件',fixed:'',width:'100'},
    {prop:'applicant_time',label:'申请日期',fixed:'',width:'100'},
    {prop:'customer_name',label:'开票客户名称',fixed:'',width:'100'},
    {prop:'party_a_name',label:'甲方名称',fixed:'',width:'100'},
    {prop:'party_a_ein',label:'甲方税号',fixed:'',width:'100'},
    {prop:'party_a_account',label:'甲方银行/账户',fixed:'',width:'100'},
    {prop:'party_a_address',label:'甲方地址/电话',fixed:'',width:'100'},
    {prop:'party_a_contact',label:'甲方联系人',fixed:'',width:'100'},
    {prop:'party_a_add_date',label:'甲方日期',fixed:'',width:'100'},
    {prop:'party_a_phone',label:'甲方联系电话',fixed:'',width:'100'},
    {prop:'party_b_contact',label:'乙方联系人',fixed:'',width:'100'},
    {prop:'party_b_phone',label:'乙方联系电话',fixed:'',width:'100'},
    {prop:'add_date',label:'乙方日期',fixed:'',width:'100'},
    {prop:'company',label:'乙方账户名称(签约公司)',fixed:'',width:'100'},
    {prop:'bank',label:'乙方开户银行',fixed:'',width:'100'},
    {prop:'account',label:'乙方账户',fixed:'',width:'100'},
    
   
]
export default columnsJson;


// WEBPACK FOOTER //
// ./src/components/BeforeApril/json/statement_list.js